/**
 * Glyphs for the Shape-operation (boolean) buttons (#764), read from
 * `src/icons/boolean-*.svg` through the shared {@link stripIconSvg} (#216).
 *
 * All five are built from the SAME two overlapping squares — one top-left, one
 * bottom-right — so the row reads as one family and the only thing that differs
 * between icons is what the operation KEEPS. Filled means kept; dashed means an
 * edge that was there and isn't any more.
 *
 * That geometry used to live here as shared constants, which made the family
 * true by construction. It is literals per file now, so the constants can't be
 * the guarantee any more — `booleanIcons.test.ts` is, by checking the five
 * files still draw on the one grid.
 *
 * They stay runtime constants rather than `<!-- svg:… -->` markers because the
 * boolean bar's buttons are built from `SHAPE_BOOLEAN_OPS` with
 * `document.createElement` — there is no markup to carry a marker.
 */
import divideRaw from "./boolean-divide.svg?raw";
import excludeRaw from "./boolean-exclude.svg?raw";
import intersectRaw from "./boolean-intersect.svg?raw";
import subtractRaw from "./boolean-subtract.svg?raw";
import uniteRaw from "./boolean-unite.svg?raw";
import { stripIconSvg } from "./stripIconSvg";

/** Everything, as one shape. Nothing was discarded, so nothing is dashed. */
export const BOOLEAN_UNITE_ICON = stripIconSvg(uniteRaw);

/** The first square's own area survives; both original outlines are dashed to
 *  show the cut. */
export const BOOLEAN_SUBTRACT_ICON = stripIconSvg(subtractRaw);

/** Only the shared middle survives; both originals are dashed. */
export const BOOLEAN_INTERSECT_ICON = stripIconSvg(intersectRaw);

/** Both outer wings survive and the overlap is punched out — a hole, not a
 *  discarded outline, so nothing is dashed. */
export const BOOLEAN_EXCLUDE_ICON = stripIconSvg(excludeRaw);

/** All three regions survive, as three separate shapes, with a real gap
 *  between them. */
export const BOOLEAN_DIVIDE_ICON = stripIconSvg(divideRaw);
